(() => {
  "use strict";

  const OD = window.OD || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const money = cents => new Intl.NumberFormat(OD.moneyLocale || "nl-NL", { style: "currency", currency: OD.currency || "EUR" }).format(cents / 100);
  const sized = (url, w) => url ? url + (url.includes("?") ? "&" : "?") + "width=" + w : "";

  /* images: reveal once loaded (fallback for cached images) */
  $$("img.lz").forEach(i => { if (i.complete) i.classList.add("in"); });

  /* ---------- toast ---------- */
  function toast(msg, icon = "info") {
    const region = $("[data-toasts]");
    if (!region) return;
    const el = document.createElement("div");
    el.className = "toast";
    el.innerHTML = `<i class="ph ph-${icon}"></i>${esc(msg)}`;
    region.append(el);
    setTimeout(() => { el.classList.add("out"); setTimeout(() => el.remove(), 200); }, 2600);
  }

  /* ---------- cart ---------- */
  const drawer = $("[data-drawer]"), scrim = $("[data-scrim]");
  const i18n = $("[data-i18n]")?.dataset || {};
  let cart = null;

  async function fetchCart() {
    const r = await fetch(`${OD.routes.cart}.js`, { headers: { Accept: "application/json" } });
    cart = await r.json();
    renderCart();
    return cart;
  }

  function renderCart() {
    if (!cart) return;
    const badge = $("[data-cart-count]");
    if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
    const body = $("[data-cart-body]"), foot = $("[data-cart-foot]");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = `<div class="drawer-empty"><i class="ph ph-shopping-cart-simple"></i><h3>${esc(i18n.empty)}</h3><p>${esc(i18n.emptyText)}</p><a class="btn btn-primary" href="${esc(i18n.allUrl)}">${esc(i18n.continue)}</a></div>`;
      foot.innerHTML = "";
      return;
    }
    const total = cart.total_price;
    const left = (OD.freeShip || 0) - total;
    const freeLine = OD.freeShip
      ? `<div class="free"><span>${left > 0 ? (i18n.freeLeft || "").replace("%s", money(left)) : i18n.freeDone}</span><div class="meter" aria-hidden="true"><span style="transform:scaleX(${Math.min(1, total / OD.freeShip)})"></span></div></div>`
      : "";
    body.innerHTML = freeLine + cart.items.map(it => `
      <div class="line" data-key="${esc(it.key)}">
        ${it.image ? `<img src="${esc(sized(it.image, 160))}" alt="" loading="lazy">` : "<span></span>"}
        <div>
          <a class="l-name" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? "" : `<div class="l-spec">${esc(it.variant_title || "")}</div>`}
          <div class="l-ctl">
            <div class="qty"><button type="button" data-q="-1" aria-label="-">−</button><input type="number" inputmode="numeric" min="0" max="999" value="${it.quantity}" data-qi aria-label="Aantal"><button type="button" data-q="1" aria-label="+">+</button></div>
            <button class="rm" type="button" data-rm>${esc(i18n.remove)}</button>
          </div>
        </div>
        <span class="l-price">${money(it.final_line_price)}</span>
      </div>`).join("");
    foot.innerHTML = `<div class="totals">
        <div><span>${esc(i18n.subtotal)}</span><span>${money(total)}</span></div>
        <div><span>${esc(i18n.shipping)}</span><span>${left > 0 ? esc(i18n.shippingCalc) : esc(i18n.shippingFree)}</span></div>
        <div class="grand"><span>${esc(i18n.total)}</span><span>${money(total)}</span></div>
      </div>
      <form action="${esc(i18n.cartUrl)}" method="post"><button class="btn btn-primary" style="width:100%" type="submit" name="checkout">${esc(i18n.checkout)} <i class="ph ph-arrow-right"></i></button></form>`;
  }

  async function changeLine(key, quantity) {
    const r = await fetch(`${OD.routes.cartChange}.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity }) });
    if (!r.ok) { toast(OD.t.error, "warning"); return fetchCart(); }
    cart = await r.json();
    renderCart();
  }

  async function addItems(items) {
    const r = await fetch(`${OD.routes.cartAdd}.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || OD.t.error);
    await fetchCart();
    return data;
  }

  let lastFocus = null;
  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    scrim.hidden = false;
    drawer.inert = false;
    drawer.setAttribute("aria-hidden", "false");
    requestAnimationFrame(() => { scrim.classList.add("on"); drawer.classList.add("open"); });
    setTimeout(() => $(".icon-btn", drawer)?.focus(), 60);
    document.body.style.overflow = "hidden";
    if (!cart) fetchCart();
  }
  function closeCart() {
    if (!drawer) return;
    scrim.classList.remove("on");
    drawer.classList.remove("open");
    drawer.inert = true;
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(() => { if (!drawer.classList.contains("open")) scrim.hidden = true; }, 340);
    lastFocus?.focus?.();
  }

  /* ---------- motion: badge + fly to cart ---------- */
  function bumpBadge() {
    if (reduce) return;
    $("[data-cart-count]")?.animate([{ transform: "scale(1)" }, { transform: "scale(1.4)" }, { transform: "scale(1)" }], { duration: 380, easing: "cubic-bezier(0.23, 1, 0.32, 1)" });
    $(".cart-btn i")?.animate([{ transform: "rotate(0)" }, { transform: "rotate(-14deg)" }, { transform: "rotate(8deg)" }, { transform: "rotate(0)" }], { duration: 420, easing: "ease-out" });
  }
  // Outer node travels on X (ease-in-out), inner on Y (ease-in): together they draw an arc into the cart.
  function flyToCart(fromEl) {
    const src = fromEl?.closest(".card, .feature, .pdp, .wrap")?.querySelector(".c-media img, .feature-media img, .gal-main img");
    const target = $(".cart-btn i");
    if (reduce || !src || !target) { bumpBadge(); return Promise.resolve(); }
    const a = src.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > innerHeight) { bumpBadge(); return Promise.resolve(); }
    const size = Math.min(a.width, a.height, 220);
    const sx = a.left + a.width / 2 - size / 2, sy = a.top + a.height / 2 - size / 2;
    const dx = b.left + b.width / 2 - (sx + size / 2), dy = b.top + b.height / 2 - (sy + size / 2);
    const outer = document.createElement("div");
    outer.className = "fly";
    outer.style.cssText = `left:${sx}px;top:${sy}px;width:${size}px;height:${size}px`;
    outer.innerHTML = `<div class="fly-in"><img src="${esc(src.currentSrc || src.src)}" alt=""></div>`;
    document.body.append(outer);
    const inner = outer.firstChild, dur = 720;
    outer.animate([{ transform: "translateX(0)" }, { transform: `translateX(${dx}px)` }], { duration: dur, easing: "cubic-bezier(0.45, 0, 0.55, 1)", fill: "forwards" });
    return inner.animate([
      { transform: "translateY(0) scale(1)", opacity: 1, borderRadius: "14px" },
      { transform: `translateY(${Math.min(-60, dy * 0.15)}px) scale(.55)`, opacity: 1, offset: 0.35 },
      { transform: `translateY(${dy}px) scale(.08)`, opacity: .6, borderRadius: "50%" },
    ], { duration: dur, easing: "cubic-bezier(0.55, 0, 0.75, 0.2)", fill: "forwards" })
      .finished.then(() => { outer.remove(); bumpBadge(); });
  }

  function swapLabel(btn, html, ms = 1500) {
    const lbl = $(".lbl", btn);
    if (!lbl) return;
    const orig = lbl.innerHTML;
    btn.classList.add("swap");
    setTimeout(() => { lbl.innerHTML = html; btn.classList.remove("swap"); }, 160);
    setTimeout(() => { btn.classList.add("swap"); setTimeout(() => { lbl.innerHTML = orig; btn.classList.remove("swap"); }, 160); }, ms);
  }

  /* ---------- product form ---------- */
  const pform = $("[data-product-form]");
  if (pform) {
    const submit = $("[data-submit]", pform);
    const err = $("[data-form-error]", pform);
    const qi = $("[data-pqi]", pform);
    $$("[data-pq]", pform).forEach(b => b.addEventListener("click", () => { qi.value = Math.max(1, Math.min(99, (+qi.value || 1) + +b.dataset.pq)); }));

    pform.addEventListener("submit", async e => {
      e.preventDefault();
      if (submit.disabled) return;
      err.hidden = true;
      const fd = new FormData(pform);
      submit.setAttribute("aria-busy", "true");
      try {
        await addItems([{ id: +fd.get("id"), quantity: +(fd.get("quantity") || 1) }]);
        swapLabel(submit, `<i class="ph ph-check"></i>${esc(submit.dataset.labelAdded)}`);
        await flyToCart(submit);
        openCart();
      } catch (x) {
        err.textContent = x.message;
        err.hidden = false;
      } finally {
        submit.removeAttribute("aria-busy");
      }
    });

    // variant switching: price, stock, image, URL
    const sel = $("[data-variant]", pform);
    if (sel) sel.addEventListener("change", () => {
      const o = sel.selectedOptions[0];
      const sold = o.hasAttribute("data-sold");
      $$("[data-price]").forEach(p => {
        const pdp = p.dataset.context === "pdp";
        p.classList.toggle("is-deal", !!o.dataset.compare);
        p.innerHTML = `<span class="now">${o.dataset.price}</span>` + (o.dataset.compare
          ? (pdp ? `<span class="was"><span class="was-lbl">Van</span> <s>${o.dataset.compare}</s></span>` : `<span class="was">${o.dataset.compare}</span>`)
          : "");
      });
      // savings line, deal line, gallery badge and real low-stock hint follow the selected variant
      const wrap = $("[data-price-wrap]");
      let save = $("[data-save-line]", wrap);
      if (o.dataset.save) {
        if (!save) { wrap.insertAdjacentHTML("beforeend", '<div class="save" data-save-line></div>'); save = $("[data-save-line]", wrap); }
        save.innerHTML = `<i class="ph-fill ph-check-circle" aria-hidden="true"></i>${o.dataset.save}`;
      } else save?.remove();
      const tier = o.dataset.tier, label = o.dataset.label;
      const dl = $("[data-deal-line]");
      if (dl) {
        dl.className = "deal-line" + (tier ? ` deal-line--${tier}` : "");
        const icon = tier === "mega" || tier === "hot" ? "ph-fill ph-lightning" : tier ? "ph-fill ph-tag" : "ph ph-seal-check";
        dl.innerHTML = `<i class="${icon}" aria-hidden="true"></i><span>${label || (tier ? (dl.dataset.dealWord || "Deal") : (dl.dataset.sharp || "Scherp geprijsd"))}</span>`;
      }
      const gal = $(".gal-main");
      gal?.querySelector("[data-tag]")?.remove();
      if (gal && tier && !sold) gal.insertAdjacentHTML("beforeend", `<span class="tag tag--${tier} tag-lg" data-tag>${tier === "mega" || tier === "hot" ? '<i class="ph-fill ph-lightning" aria-hidden="true"></i>' : ""}<b>-${o.dataset.pct}%</b>${label ? `<span class="tag-label">${label}</span>` : ""}</span>`);
      const low = $("[data-low-wrap]"); if (low) low.innerHTML = o.dataset.low || "";
      submit.disabled = sold;
      $(".lbl", submit).innerHTML = sold ? esc(submit.dataset.labelSold) : `<i class="ph ph-shopping-cart-simple"></i>${esc(submit.dataset.labelAdd)}`;
      const mb = $("[data-mbuy-btn]"); if (mb) mb.disabled = sold;
      if (o.dataset.img) setMainImage(o.dataset.img);
      const url = new URL(location.href); url.searchParams.set("variant", o.value); history.replaceState(null, "", url);
    });

    // mobile sticky buy bar mirrors the main form
    const mb = $("[data-mbuy]"), box = $("[data-buybox]");
    if (mb && box && "IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => mb.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0)).observe(box);
      $("[data-mbuy-btn]", mb)?.addEventListener("click", () => pform.requestSubmit());
    }
  }

  /* ---------- gallery ---------- */
  function setMainImage(url) {
    const main = $(".gal-main img");
    if (!main) return;
    main.classList.add("fading");
    setTimeout(() => {
      main.removeAttribute("srcset");
      main.src = url;
      main.onload = () => main.classList.remove("fading");
    }, 160);
  }
  $$("[data-thumb]").forEach(b => b.addEventListener("click", () => {
    $$("[data-thumb]").forEach(x => x.setAttribute("aria-current", String(x === b)));
    setMainImage(b.dataset.thumb);
  }));

  /* ---------- global clicks ---------- */
  document.addEventListener("click", async e => {
    const t = e.target.closest("button, a");
    if (!t) return;
    if (t.matches("[data-open-cart]")) { e.preventDefault(); openCart(); return; }
    if (t.matches("[data-close-cart]")) { closeCart(); return; }
    if (t.matches("[data-add]")) {
      e.preventDefault();
      t.classList.add("swap");
      try {
        await addItems([{ id: +t.dataset.add, quantity: 1 }]);
        t.classList.remove("swap"); t.classList.add("done"); t.innerHTML = '<i class="ph ph-check"></i>';
        flyToCart(t);
        const name = t.closest(".card")?.querySelector(".c-name")?.textContent?.trim();
        toast(`${name || ""} ${OD.t.added}`.trim(), "check-circle");
        setTimeout(() => { t.classList.add("swap"); setTimeout(() => { t.classList.remove("done", "swap"); t.innerHTML = '<i class="ph ph-plus"></i>'; }, 120); }, 1600);
      } catch (x) { t.classList.remove("swap"); toast(x.message, "warning"); }
      return;
    }
    if (t.matches("[data-add-btn]")) {
      e.preventDefault();
      try {
        await addItems([{ id: +t.dataset.addBtn, quantity: 1 }]);
        swapLabel(t, `<i class="ph ph-check"></i>${esc(OD.t.added)}`);
        await flyToCart(t);
        openCart();
      } catch (x) { toast(x.message, "warning"); }
      return;
    }
    const line = t.closest(".drawer .line");
    if (line && t.matches("[data-q]")) {
      const input = $("[data-qi]", line);
      changeLine(line.dataset.key, Math.max(0, (+input.value || 0) + +t.dataset.q));
      return;
    }
    if (line && t.matches("[data-rm]")) {
      line.classList.add("leaving");
      setTimeout(() => changeLine(line.dataset.key, 0), 180);
    }
  });
  document.addEventListener("change", e => {
    const line = e.target.closest(".drawer .line");
    if (line && e.target.matches("[data-qi]")) changeLine(line.dataset.key, Math.max(0, +e.target.value || 0));
  });
  scrim?.addEventListener("click", closeCart);

  /* ---------- predictive search ---------- */
  const sForm = $("[data-search]"), sInput = sForm && $('input[name="q"]', sForm), sBox = $("#suggest");
  let sIdx = -1, sTimer, sCtrl;
  function showSuggest(open) {
    if (!sBox) return;
    if (open) { sBox.hidden = false; requestAnimationFrame(() => sBox.dataset.state = "open"); }
    else { sBox.dataset.state = "closed"; setTimeout(() => { if (sBox.dataset.state === "closed") sBox.hidden = true; }, 160); }
    sInput.setAttribute("aria-expanded", String(open));
  }
  if (sInput && sBox) {
    sInput.addEventListener("input", () => {
      const q = sInput.value.trim();
      sIdx = -1;
      clearTimeout(sTimer);
      if (q.length < 2) return showSuggest(false);
      sTimer = setTimeout(async () => {
        sCtrl?.abort(); sCtrl = new AbortController();
        try {
          const r = await fetch(`${OD.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, { signal: sCtrl.signal });
          const data = await r.json();
          const res = data?.resources?.results?.products || [];
          const allUrl = `${OD.routes.search}?q=${encodeURIComponent(q)}&type=product`;
          sBox.innerHTML = res.length
            ? res.map(p => `<a role="option" href="${esc(p.url)}">${p.image ? `<img src="${esc(sized(p.image, 120))}" alt="">` : "<span></span>"}<span><span class="s-name">${esc(p.title)}</span><br><span class="s-meta">${esc(p.vendor)}${p.available ? "" : ", " + esc(sBox.dataset.sold)}</span></span><span class="s-price">${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join("") +
              `<a class="s-all" href="${esc(allUrl)}">${esc((sBox.dataset.all || "").replace("%s", q))}</a>`
            : `<div class="s-empty">${esc((sBox.dataset.none || "").replace("%s", q))}</div>`;
          showSuggest(true);
        } catch (x) { if (x.name !== "AbortError") showSuggest(false); }
      }, 140);
    });
    sInput.addEventListener("keydown", e => {
      const opts = $$("a", sBox);
      if ((e.key === "ArrowDown" || e.key === "ArrowUp") && opts.length) {
        e.preventDefault();
        sIdx = (sIdx + (e.key === "ArrowDown" ? 1 : -1) + opts.length) % opts.length;
        opts.forEach((o, i) => o.setAttribute("aria-selected", String(i === sIdx)));
      } else if (e.key === "Escape") { showSuggest(false); sInput.blur(); }
      else if (e.key === "Enter" && sIdx >= 0 && opts[sIdx]) { e.preventDefault(); location.href = opts[sIdx].href; }
    });
    document.addEventListener("click", e => { if (!sForm.contains(e.target)) showSuggest(false); });
  }
  document.addEventListener("keydown", e => {
    if (e.key === "/" && sInput && !/input|textarea|select/i.test(document.activeElement.tagName)) { e.preventDefault(); sInput.focus(); }
    if (e.key === "Escape" && drawer?.classList.contains("open")) closeCart();
    if (e.key === "Escape") $$("[data-drop][open]").forEach(d => d.open = false);
  });

  /* nav dropdowns: close others / outside click */
  $$("[data-drop]").forEach(d => d.addEventListener("toggle", () => { if (d.open) $$("[data-drop]").forEach(x => x !== d && (x.open = false)); }));
  document.addEventListener("click", e => { $$("[data-drop][open]").forEach(d => { if (!d.contains(e.target)) d.open = false; }); });

  /* ---------- tabs (featured deals) ---------- */
  $$("[data-tabs]").forEach(sec => {
    const tabs = $$("[data-tab]", sec);
    tabs.forEach(tab => tab.addEventListener("click", () => {
      tabs.forEach(x => { const on = x === tab; x.setAttribute("aria-selected", on); x.setAttribute("aria-pressed", on); });
      $$("[data-panel]", sec).forEach(p => { p.hidden = p.dataset.panel !== tab.dataset.tab; if (!p.hidden) reveal(p.parentNode, p); });
    }));
  });

  /* ---------- collection / search facets ---------- */
  const facets = $("[data-facets]");
  const sortSel = $("[data-sort]");
  function applyFacets() {
    const url = new URL(facets ? facets.action : location.href, location.origin);
    const params = facets ? new URLSearchParams(new FormData(facets)) : new URLSearchParams(location.search);
    [...params.keys()].forEach(k => { if (params.get(k) === "") params.delete(k); });
    if (sortSel) params.set("sort_by", sortSel.value);
    if (!facets) { const q = new URLSearchParams(location.search); q.forEach((v, k) => { if (!params.has(k)) params.append(k, v); }); }
    params.delete("page");
    location.href = url.pathname + "?" + params.toString();
  }
  if (facets && !matchMedia("(max-width: 900px)").matches) {
    facets.addEventListener("change", e => { if (e.target.type === "checkbox") applyFacets(); });
    $$('input[type="number"]', facets).forEach(i => i.addEventListener("keydown", e => { if (e.key === "Enter") { e.preventDefault(); applyFacets(); } }));
  }
  facets?.addEventListener("submit", e => { e.preventDefault(); applyFacets(); });
  sortSel?.addEventListener("change", applyFacets);
  const fl = $("[data-filters]");
  $("[data-f-open]")?.addEventListener("click", () => fl?.classList.add("open"));
  $$("[data-f-close]").forEach(b => b.addEventListener("click", () => fl?.classList.remove("open")));

  /* ---------- ticker: clone set so the -25% loop is seamless ---------- */
  const tk = $("[data-ticker]");
  if (tk) {
    const set = $(".ticker-set", tk);
    for (let i = 0; i < 3; i++) { const c = set.cloneNode(true); c.setAttribute("aria-hidden", "true"); $$("a", c).forEach(a => a.tabIndex = -1); tk.append(c); }
  }

  /* ---------- scroll reveal: one staggered entrance per grid ---------- */
  const revealIO = "IntersectionObserver" in window && !reduce && !window.Shopify?.designMode ? new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); revealIO.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -8% 0px" }) : null;
  function reveal(scope, only) {
    if (!revealIO) return;
    (only ? [only] : $$(".bento, .grid, .biz", scope)).forEach(group => {
      [...group.children].forEach((el, i) => { el.classList.add("rv"); el.style.setProperty("--d", `${(i % 8) * 55}ms`); revealIO.observe(el); });
    });
  }
  reveal(document);

  /* init */
  fetchCart().catch(() => {});
})();

/* ---------- return form: inline validation, 14-day hint, photo hint ---------- */
(() => {
  const form = document.querySelector("[data-ret]");
  const done = document.querySelector("[data-ret-done]");
  if (done) { done.scrollIntoView({ block: "center" }); done.focus({ preventScroll: true }); }
  if (!form || !form.querySelector("input")) return;
  const q = (s, r = form) => r.querySelector(s);
  const date = q('[data-rule="date"]');
  if (date) date.max = new Date().toISOString().slice(0, 10);
  const setErr = (el, msg) => {
    const f = el.closest(".field"), e = q(".err", f);
    if (e) { e.textContent = msg || ""; e.hidden = !msg; }
    f.querySelectorAll("input, textarea").forEach(i => i.setAttribute("aria-invalid", msg ? "true" : "false"));
  };
  const msgFor = el => {
    const v = (el.value || "").trim();
    if (el.type === "email") return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? "" : "Vul een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.";
    if (el.dataset.rule === "order") return /\d{3,}/.test(v) ? "" : "Vul je ordernummer in, bijvoorbeeld #1023.";
    if (el.dataset.rule === "date") return v ? "" : "Kies de datum waarop je de bestelling hebt ontvangen.";
    if (el.type === "checkbox") return el.checked ? "" : "Bevestig dat je het product goed verpakt terugstuurt.";
    return v.length > 1 ? "" : (el.tagName === "TEXTAREA" ? "Laat ons weten welk product je terugstuurt." : "Vul je naam in.");
  };
  const required = () => [...form.querySelectorAll("input[required]:not([type=radio]), textarea[required]")];
  required().forEach(el => el.addEventListener("blur", () => { if (el.value) setErr(el, msgFor(el)); }));
  date?.addEventListener("change", () => { q("[data-late]").hidden = !((Date.now() - new Date(date.value)) / 864e5 > 14); });
  form.addEventListener("change", e => {
    if (e.target.type === "radio") { q("[data-photo]").hidden = !/beschadig|defect/i.test(e.target.value); setErr(e.target, ""); }
    if (e.target.type === "checkbox") setErr(e.target, "");
  });
  form.addEventListener("submit", e => {
    let ok = true;
    required().forEach(el => { const m = msgFor(el); setErr(el, m); if (m) ok = false; });
    const radio = q('input[type="radio"]');
    if (radio && !q('input[type="radio"]:checked')) { setErr(radio, "Kies een reden."); ok = false; }
    if (!ok) { e.preventDefault(); q('[aria-invalid="true"]')?.focus(); return; }
    q('button[type="submit"]').disabled = true;
  });
})();

/* ---------- review drawer / bottom sheet ---------- */
(() => {
  const drawer = document.querySelector("[data-rv-drawer]"), scrim = document.querySelector("[data-rv-scrim]");
  if (!drawer) return;
  let lastFocus = null;
  const open = () => {
    lastFocus = document.activeElement;
    drawer.hidden = false; scrim.hidden = false;
    document.documentElement.classList.add("rv-lock");
    requestAnimationFrame(() => requestAnimationFrame(() => { drawer.dataset.state = "open"; scrim.classList.add("on"); }));
    setTimeout(() => drawer.querySelector("[data-rv-close]").focus({ preventScroll: true }), 60);
  };
  const close = () => {
    if (drawer.dataset.state !== "open") return;
    drawer.dataset.state = "closed"; scrim.classList.remove("on");
    document.documentElement.classList.remove("rv-lock");
    setTimeout(() => { if (drawer.dataset.state === "closed") { drawer.hidden = true; scrim.hidden = true; } }, 320);
    lastFocus?.focus?.({ preventScroll: true });
  };
  document.querySelectorAll("[data-rv-open]").forEach(b => b.addEventListener("click", open));
  scrim.addEventListener("click", close);
  drawer.querySelector("[data-rv-close]").addEventListener("click", close);
  document.addEventListener("keydown", e => {
    if (drawer.dataset.state !== "open") return;
    if (e.key === "Escape") close();
    if (e.key === "Tab") {
      const f = [...drawer.querySelectorAll("a, button")];
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  let y0 = null, t0 = 0;
  drawer.addEventListener("pointerdown", e => { if (e.pointerType === "touch" && e.target.closest(".rv-head")) { y0 = e.clientY; t0 = Date.now(); drawer.setPointerCapture(e.pointerId); } });
  drawer.addEventListener("pointermove", e => { if (y0 == null) return; drawer.style.transition = "none"; drawer.style.transform = `translateY(${Math.max(0, e.clientY - y0)}px)`; });
  drawer.addEventListener("pointerup", e => {
    if (y0 == null) return;
    const dy = e.clientY - y0, v = dy / Math.max(1, Date.now() - t0);
    drawer.style.transform = ""; drawer.style.transition = ""; y0 = null;
    if (dy > 120 || v > 0.11) close();
  });
})();
